import React from 'react';

import WidgetComponent from '../../widget/WidgetComponent';
import Widget from '../../widget/Widget';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';


import '../../css/analysis.css';

class QualificationHonor extends WidgetComponent
{
    constructor(props)
    {
        super(props);

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        let entname = Widget.getSessionStorage("entname");

        this.state = {
            // 企业资质
            options:{
                'url':url,
                'records':5,
                'title':'企业资质'
            },
            columns:[
                {name:'NAME', title:'名称', type:'string'},
                {name:'CERTNO', title:'证书编号', type:'string'},
                {name:'AUTHORG', title:'认证机构', type:'string'},
                {name:'ISSDATE', title:'发证日期', type:'string'},
                {name:'EFFDATE', title:'有效期至', type:'date'},
                {name:'AUTHORG', title:'认证机构', type:'string'},
                {name:'AUTHCONTENT', title:'认证内容', type:'string'},
            ],
            params :{
                'service':'getQualificationInfo',
                'user':UID,
                'ENTNAME' : entname
            },
            //企业荣誉
            options2:{
                'url':url,
                'records':5,
                'title':'企业荣誉'
            },
            columns2:[
                {name:'TITLE', title:'荣誉名称', type:'string'},
                {name:'EVALORG', title:'评价机构', type:'string'},
                {name:'EVALYEAR', title:'评选日期', type:'string'},
            ],
            params2 :{
                'service':'getHonorInfo',
                'user':UID,
                'ENTNAME' : entname
            },
        };

        this.onLoadToken = this.onLoadToken.bind(this);

        Config.getHermesAccess( this.onLoadToken );
    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        let { params, params2 } = this.state;
        if( result.status===0 )
        {
            params["access"] =  result.result.token;
            params2["access"] =  result.result.token;
   
            this.setState({
                params:params,
                params2:params2,
            }); 
        }
        else
        {
            return ;
        }  
    }

    change( item )
    {
        
        for( let i=0; i<item.target.parentNode.childNodes.length; i++ )
        {
            item.target.parentNode.childNodes[i].className = "title-label";
        }
        item.target.className = 'title-label title-label-active';

        let e = document.getElementById(item.currentTarget.id.substring(1));
        e.scrollIntoView({behavior:'smooth'}); 
    }

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            this.state["params2"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }  
    }

    render() 
	{
        const { options, columns, params, options2, columns2, params2 } = this.state;
        
        return(
            <div className="page">
                {/* label */}
                {/* <div className="page-weidu entity-title">
                    <div id="0entityQualification" className="title-label title-label-active" onClick={this.change.bind(this)}>企业资质</div>
                    <div id="0entityHonor" className="title-label " onClick={this.change.bind(this)}>企业荣誉</div>
                </div> */}

                <div className="page-content page-overflow page-content-custom white padding-20">
                    {/* 企业资质 */}
                    <div id="entityQualification" className="content-top content-canvas-custom border-top-left-radius-0">
                        <WidgetInterfaceTable options={options} columns={columns} params={params} />
                    </div>

                    {/* 企业荣誉 */}
                    <div id="entityHonor" className="content-top content-canvas-custom ">
                        <WidgetInterfaceTable options={options2} columns={columns2} params={params2} />
                    </div>
                </div>
            </div>
        );
    }

}

export default QualificationHonor